module.exports = __webpack_public_path__ + "img/1lyoptions.e9b6bbb2.png";